import React from 'react';
import { MdInfoOutline, MdStarBorder } from 'react-icons/md';
import { FaInfo, FaPlus } from 'react-icons/fa';
import { TiInputChecked } from 'react-icons/ti';
import Input from '../../../../components/Input';
import { Duration, ItemPrice, PriceWrapper, Container } from './styles';
import Loading from '../../../../components/Loading';
import Button from '../../../../components/Button';
import Tooltip from '../../../../components/Tooltip';
import { filtersOptions } from '../../../../shared/constants';

interface IndividualItemProps {
  item: any;
  type: string;
  isSelected: boolean;
  data: any;
  searchLoading?: boolean;
  itemAsJSON: any;
  handleFeePeriodChange: (value: number, item: any, type: string) => void;
  selectedItemsId?: number[];
  openViewItemDescriptionModal: (type: string, item: any) => void;
  loadingStates?: any;
  handleAditionalItem: (item: any, type: string) => Promise<void>;
  mandatory?: boolean;
  suggestive?: boolean;
}

const IndividualItem: React.FC<IndividualItemProps> = ({
  item,
  type,
  isSelected,
  data,
  searchLoading,
  itemAsJSON,
  handleFeePeriodChange,
  selectedItemsId,
  openViewItemDescriptionModal,
  loadingStates,
  handleAditionalItem,
  mandatory,
  suggestive,
}) => {
  let flagImg = '';
  let partner = '';
  let campus = '';
  let itemName = '';
  let accommodationName = '';
  let city = '';
  item.city ? (city = item.city.name) : (city = '');
  let price = 0;
  let currency = '';
  const typePeriod = item.typePeriod ? `${item.typePeriod}(s)` : '';

  switch (type) {
    case filtersOptions.FILTERS_ACCOMMODATIONS:
      flagImg = `${process.env.REACT_APP_NG_URL}/images/flags/${item.accommodation.city.country?.flagName}.png`;
      partner = item.partner;
      item.campus ? (campus = `${item.campus.campus.name} - `) : (campus = '');
      accommodationName = item
        ? `${item.accommodation.name} - ${item.type} Room - ${item.bathroom} Bathroom - ${item.regime}`
        : '';
      item.totalThisAccommodation
        ? (price = item.totalThisAccommodation.value)
        : 0;
      item.totalThisAccommodation
        ? (currency = item.totalThisAccommodation.currency)
        : (currency = '');
      break;
    case filtersOptions.FILTERS_INSURANCES:
      flagImg = item.campus
        ? `${process.env.REACT_APP_NG_URL}/images/flags/${item.campus.city.country?.flagName}.png`
        : '';
      console.log(item);
      item.totalThisFee ? (price = item.totalThisFee.value) : 0;
      // eslint-disable-next-line no-nested-ternary
      partner = item.campus ? (item.campus.school ? item.campus.name : '') : '';
      item.campus ? (campus = `${item.campus.name} - `) : (campus = '');
      item.name ? (itemName = item.name) : (itemName = '');
      item.totalThisFee ? (currency = item.totalThisFee.currency) : '';
      break;
    case filtersOptions.FILTERS_ADDONS:
      flagImg = item.campus
        ? `${process.env.REACT_APP_NG_URL}/images/flags/${item.campus.city.country?.flagName}.png`
        : '';
      item.totalThisFee ? (price = item.totalThisFee.value) : 0;
      item.campus?.school
        ? (partner = item.campus.school.name)
        : (partner = item.partner);
      item.campus?.school
        ? (campus = `${item.campus.school.name} - `)
        : (campus = '');
      item.name ? (itemName = item.name) : (itemName = '');
      item.totalThisFee ? (currency = item.totalThisFee.currency) : '';
      break;
    default:
      break;
  }
  const formatedPrice = price.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
  });
  const schoolLogo = `${process.env.REACT_APP_AMZ_API}/base/school-logos/school_${itemAsJSON?.coursecampus?.campus?.school_id}.jpg`;

  return (
    <Container isSelected={isSelected}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div
          style={{
            width: '30%',
            display: 'flex',
            justifyContent: 'center',
            marginRight: '5px',
          }}
        >
          {!item.partner_id && schoolLogo ? (
            <img src={schoolLogo} alt="" height="30px" />
          ) : (
            <div>
              <MdInfoOutline size={15} color="var(--primary)" />
              <span style={{ paddingLeft: '3px', paddingRight: '5px' }}>
                From Partner
              </span>
            </div>
          )}
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            width: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
            }}
          >
            <div>
              {flagImg ? (
                <img
                  src={flagImg}
                  alt=""
                  height="20px"
                  style={{ marginRight: '5px' }}
                />
              ) : (
                ' '
              )}
            </div>
            <span>{city}</span>
            {mandatory && (
              <div
                style={{
                  display: 'flex',
                  gap: '3px',
                  flexDirection: 'column',
                }}
              >
                <span>
                  <MdStarBorder size={15} /> Mandatory Under {item.underAge} Fee
                </span>
              </div>
            )}
            {suggestive && (
              <div
                style={{
                  display: 'flex',
                  gap: '3px',
                  flexDirection: 'column',
                }}
              >
                <span>
                  <MdStarBorder size={15} /> Suggestive Fee
                </span>
              </div>
            )}
          </div>
          {/* Item Info */}
          <span>{`${campus} ${partner}`}</span>
          {/* Accommodation name */}
          <strong>{accommodationName}</strong>
          <strong>{itemName}</strong>
        </div>
      </div>
      <PriceWrapper>
        {/* Item period */}
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          }}
        >
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <div>
              {item.typePeriod !== 'fixed' ? (
                <>
                  <Duration
                    onClick={e => e.stopPropagation()}
                    key={`duration_${item.id}`}
                  >
                    <Input
                      defaultValue={data?.duration}
                      type="number"
                      name="item_duration"
                      id={`duration_${data.id}`}
                      onChange={e => {
                        handleFeePeriodChange(
                          (e.target.value as unknown) as number,
                          item,
                          type
                        );
                      }}
                      isDisabled={
                        mandatory || selectedItemsId?.includes(item.id)
                      }
                    />
                  </Duration>
                  <span>{typePeriod}</span>
                </>
              ) : (
                <span style={{ width: '68px', textAlign: 'center' }}>
                  Fixed fee
                </span>
              )}
            </div>
            {/* Item price */}
            <ItemPrice>
              {currency}
              {item.price ? (
                formatedPrice
              ) : (
                <span
                  style={{
                    color: 'var(--light-red)',
                  }}
                >
                  Invalid duration
                </span>
              )}
            </ItemPrice>
            <Tooltip title="Details">
              <Button
                style={{
                  padding: '5px',
                  width: '39px',
                  height: '39px',
                }}
                type="button"
                className="btn-white btn-outline btn-outline--gray"
                onClick={() => {
                  openViewItemDescriptionModal(type, item);
                }}
              >
                <FaInfo />
              </Button>
            </Tooltip>
            <Button
              loading={loadingStates[item.id]}
              type="button"
              className="btn-green"
              style={{
                padding: '5px',
                width: '39px',
                height: '39px',
              }}
              onClick={() => {
                handleAditionalItem(item, type);
              }}
              disabled={
                mandatory ||
                !item.price ||
                loadingStates[item.id] ||
                selectedItemsId?.includes(item.id)
              }
            >
              <FaPlus />
            </Button>
          </div>
          {(mandatory || selectedItemsId?.includes(item.id)) && (
            <span
              style={{
                marginTop: item.typePeriod === 'fixed' ? '10px' : '0px',
              }}
            >
              <TiInputChecked size={18} color="var(--green)" /> Added to quote
            </span>
          )}
        </div>
      </PriceWrapper>
    </Container>
  );
};

export default IndividualItem;
